import { Component, OnInit } from '@angular/core';
import { MapService } from 'src/app/services/map.service';
import { PointsService } from 'src/app/services/points.service';
import olMap from 'ol/Map';
import { AddProjectControlService } from 'src/app/services/add-project-control.service';
import { Project } from 'src/app/models/project';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { NavaidDTOCalculation, NavaidModel } from 'src/app/models/navaid';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { Feature } from 'ol';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { ConfigurationModel } from 'src/app/models/configuration';
import { ProjectService } from 'src/app/services/project.service';
import { VectorLayerDMTR } from 'src/app/menu/view-menu/layer';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { ProcedureModel } from 'src/app/models/procedure';
import { FeatureType } from 'src/app/models/EnumTypes';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { TabsService } from 'src/app/services/tabsService';
import { AirSpaceBoundaryModel } from 'src/app/models/air-space-boundary';

@Component({
  selector: 'app-project-control',
  templateUrl: './add-project-control.component.html',
  styleUrls: ['./add-project-control.component.scss'],
  standalone: false
})
export class AddProjectControlComponent implements OnInit {
    active:boolean = true;
    addProjectController : AddProjectControlService;
    projectController : ProjectService;
    pointsController : PointsService;
    configController : ConfigurationService;
    modalService : ModalControlService;
    mapService : MapService;

    colapsableLabelNavAidsList:boolean = false;
    colapsableDivNavAidsList:boolean = false;
    colapsableLabelCoPointsList:boolean = false;
    colapsableDivCoPointsList:boolean = false;
    colapsableLabelProceduresList:boolean = false;
    colapsableDivProceduresList:boolean = false;
    colapsableLabelBoundariesList:boolean = false;
    colapsableDivBoundariesList:boolean = false;


    map:olMap;


    constructor(addProjectController : AddProjectControlService, mapService : MapService, pointsController : PointsService,
       configController: ConfigurationService, modalService : ModalControlService, projectService : ProjectService, private toolsControlService : ToolsControlService,
       private globalSelectionService: GlobalSelectionControlService,
       public menuController : MenuManagementService,
       public tabsService : TabsService

       ){
      this.addProjectController = addProjectController;
      this.projectController = projectService;
      this.pointsController = pointsController;
      this.configController = configController;
      this.modalService = modalService;
      this.mapService = mapService;
      this.map = this.mapService.getMap('map');
      this.addProjectController.selectedProject = new Project();

    }
    ngOnInit(): void {

    }
    cancelProjectEdition():void{
      this.addProjectController.active = !this.addProjectController.active;
      this.addProjectController.selectedProject = new Project();
      this.toolsControlService.navigationOnTop = false;
      this.projectController.getAllProjects();
      this.tabsService.closeTab();
    }

    colapsableLabelNavAidsListTrigger():void {
      this.colapsableLabelNavAidsList = !this.colapsableLabelNavAidsList;
      this.colapsableDivNavAidsList = !this.colapsableDivNavAidsList;
    }

    colapsableLabelCoPointsListTrigger():void {
      this.colapsableLabelCoPointsList = !this.colapsableLabelCoPointsList;
      this.colapsableDivCoPointsList = !this.colapsableDivCoPointsList;
    }

    colapsableLabelProceduresListTrigger():void {
      this.colapsableLabelProceduresList = !this.colapsableLabelProceduresList;
      this.colapsableDivProceduresList = !this.colapsableDivProceduresList;
    }

    colapsableLabelBoundariesListTrigger():void {
      this.colapsableLabelBoundariesList = !this.colapsableLabelBoundariesList;
      this.colapsableDivBoundariesList = !this.colapsableDivBoundariesList;
    }

    async addSelectedNavaids() {
      for await (const element of this.pointsController.getSelectedFeatures()) {
        if(element.getProperties().featureType == FeatureType.Navaid){//navaid
          let navaidToAdd : NavaidModel = new NavaidModel();
          navaidToAdd = this.pointsController.transformFeatureInNavaid(element);
          if(!this.configController.currentConfiguration.navaids.some(navaid => navaid.id == navaidToAdd.id)){
            this.configController.currentConfiguration.navaids.push(navaidToAdd);
          } else {
            //this.modalService.showMesssageModal("Warning", "The selected navaid is already on the list.");
          }
        }
      }
    }

    async addSelectedCoordPoints() {
      for await (const element of this.pointsController.getSelectedFeatures()) {
        if(element.getProperties().featureType == FeatureType.CoordinatePoint){//coord_points
          let coordPointToAdd : CoordinatePointModel = new CoordinatePointModel();
          coordPointToAdd = this.pointsController.transformFeatureInCoordinatePoint(element);
          if(!this.configController.currentConfiguration.coordPoints.some(point => point.id == coordPointToAdd.id)){
            this.configController.currentConfiguration.coordPoints.push(coordPointToAdd);
          } else {
            //this.modalService.showMesssageModal("Warning", "The selected navaid is already on the list.");
          }
        }
      }
    }

    async addSelectedProcedures() {
      for await (const element of this.pointsController.getSelectedFeatures()) {
        if(element.getProperties().featureType == FeatureType.Procedure){//procedures
          let procedureToAdd : ProcedureModel = new ProcedureModel();
          procedureToAdd = this.pointsController.transformFeatureInProcedure(element);
          if(!this.configController.currentConfiguration.procedures.some(proc => proc.id == procedureToAdd.id)){
            this.configController.currentConfiguration.procedures.push(procedureToAdd);
          } else {
            //this.modalService.showMesssageModal("Warning", "The selected navaid is already on the list.");
          }
        }
      }
    }

    async addSelectedAirspaceBoundaries() {
      for await (const element of this.pointsController.getSelectedFeatures()) {
        if(element.getProperties().featureType == FeatureType.AirSpaceBoundary){//procedures
          let airspaceToAdd : AirSpaceBoundaryModel = new AirSpaceBoundaryModel();
          airspaceToAdd = this.pointsController.transformFeatureInAirspaceBoundary(element);
          if(!this.configController.currentConfiguration.airspaceBoundaries.some(air => air.id == airspaceToAdd.id)){
            this.configController.currentConfiguration.airspaceBoundaries.push(airspaceToAdd);
          } else {
            //this.modalService.showMesssageModal("Warning", "The selected navaid is already on the list.");
          }
        }
      }
    }

    selectAllNavaids(){
      this.configController.currentConfiguration.navaids.forEach ( nav => {
        nav.isselected = true;
      });
    }

    selectAllCoordPoints(){
      this.configController.currentConfiguration.coordPoints.forEach ( point => {
        point.isselected = true;
      });
    }

    selectAllProcedures(){
      this.configController.currentConfiguration.procedures.forEach ( proc => {
        proc.isselected = true;
      });
    }

    selectAllAirspaceBoundaries(){
      this.configController.currentConfiguration.airspaceBoundaries.forEach ( airspace => {
        airspace.isselected = true;
      });
    }

    clearSelectedNavaids(){
      var me = this;
      this.mapService.clearSelections();

      this.pointsController.getSelectedFeatures().forEach(function(feature){
        me.removeSelectedFeature(feature);
      });
    }

  clearSelectedCoordPoints() {
      this.mapService.clearSelections();
      this.pointsController.clearSelectedCoordinatePoints(false);
    }

    clearSelectedProcedures(){
      var me = this;
      this.mapService.clearSelections();

      this.pointsController.getSelectedFeatures().forEach(function(feature){
        me.removeSelectedFeature(feature);
      });
    }

    clearSelectedAirspaceBondaries(){
      var me = this;
      this.mapService.clearSelections();

      this.pointsController.getSelectedFeatures().forEach(function(feature){
        me.removeSelectedFeature(feature);
      });
    }

    removeSelectedFeature(feature:Feature):void{
      feature.setStyle(null);
      this.pointsController.removeSelectedFeature(feature);
    }

    removeSelectedNavaids(){
      this.configController.currentConfiguration.navaids = this.configController.currentConfiguration.navaids.filter(nav => !nav.isselected);
    }

    removeSelectedCoordPoints(){
      this.configController.currentConfiguration.coordPoints = this.configController.currentConfiguration.coordPoints.filter(point => !point.isselected);
    }

    removeSelectedProcedures(){
      this.configController.currentConfiguration.procedures = this.configController.currentConfiguration.procedures.filter(proc => !proc.isselected);
    }

    removeSelecteAirspaceBoundaries(){
      this.configController.currentConfiguration.airspaceBoundaries = this.configController.currentConfiguration.airspaceBoundaries.filter(airspace => !airspace.isselected);
    }

  selectNavaidFeatures() {
      // Disabled this initial line of code as it resets the visibility of navaids layers
      // this.globalSelectionService.navaidsLayers.childLayers.forEach( child => {
      //   child.showAll();
      // });
      this.configController.currentConfiguration.navaids.forEach( navaid => {
        if(navaid.isselected){
          //let feature:Feature = this.pointsController.
          // let feature:Feature = this.pointsController.navaidsLayers.childLayers[0].layers.find((element) => element.id === navaid.navaidtype.toLowerCase())
          // .olLayer.getSource().getFeatureById(navaid.id);
          // let layer : VectorLayerDMTR = this.pointsController.navaidsLayers.childLayers[0].layers.find((element) => element.id === navaid.navaidtype.toLowerCase())
          // .olLayer;
          let typeId = String(navaid.navaidtype).toLowerCase();

          // Find the layer wrapper for this navaid type
          let layer =
            this.globalSelectionService.navaidsLayers.childLayers[0].layers?.find(
              (l: any) => l.id === typeId
            );

          let feature: Feature = layer.olLayer
            ?.getSource()
            ?.getFeatureById(navaid.id);

          if (feature) {
            this.setSelectedFeature(layer.olLayer, feature);
          }

          layer.visible = true;

          if (layer.olLayer?.setVisible) {
              layer.olLayer.setVisible(true);
          }
        }
      });

    }

    selectCoordPointFeatures(){
      // this.globalSelectionService.coordinatePointsLayers.childLayers.forEach( child => {
      //   child.showAll();
      // });
      this.configController.currentConfiguration.coordPoints.forEach( point => {
        if (point.isselected) {
          // const layerId: string = this.pointsController.getLayerIdFromCoordPointType(point.type);
          // this.globalSelectionService.coordinatePointsLayers.childLayers[0].layers.find(layer => layer.id == layerId).visible = true;
          this.globalSelectionService.setSelectedCoordinatePointModel(point);
        }
      });

    }

    selectProcedureFeatures(){
      this.globalSelectionService.proceduresLayers.childLayers.forEach( child => {
        child.showAll();
      });
      this.configController.currentConfiguration.procedures.forEach( proc => {
        if(proc.isselected){
          //let feature:Feature = this.pointsController.
          let feature:Feature = null;
          this.pointsController.proceduresLayers.childLayers[0].layers.find((element) => element.id === proc.proceduretype.toLowerCase())
          .olLayer.getSource().getFeatures().forEach( feat => {
            if(feat.getProperties().id == proc.id){
              feature = feat;
              return;
            }
          })
          let layer : VectorLayerDMTR = this.pointsController.proceduresLayers.childLayers[0].layers.find((element) => element.id === proc.proceduretype.toLowerCase())
          .olLayer;
          if(feature != null){
            this.setSelectedFeature(layer, feature);
          }
        }
      });

    }

    selectAirspaceFeatures(){
      this.globalSelectionService.airspaceboundaryLayers.childLayers.forEach( child => {
        child.showAll();
      });
      this.configController.currentConfiguration.airspaceBoundaries.forEach( airspace => {
        if(airspace.isselected){
          let feature:Feature = null;
          this.pointsController.airspaceboundariesLayers.childLayers[0].layers[0]
          .olLayer.getSource().getFeatures().forEach( feat => {
            if(feat.getProperties().id == airspace.id){
              feature = feat;
              return;
            }
          })
          let layer : VectorLayerDMTR = this.pointsController.airspaceboundariesLayers.childLayers[0].layers[0]
          .olLayer;
          this.setSelectedFeature(layer, feature);
        }
      });

    }


    setSelectedFeature(layer:VectorLayerDMTR, feature:Feature):void{
      feature.setStyle(layer.getStyleSelected());
      this.pointsController.addSelectedFeature(feature);
    }

    unSelectNavaidFeatures(){
      this.configController.currentConfiguration.navaids.forEach( navaid => {
        if(navaid.isselected){
          let feature:Feature = this.pointsController.navaidsLayers.childLayers[0].layers.find((element) => element.id === navaid.navaidtype.toLowerCase())
          .olLayer.getSource().getFeatureById(navaid.id);
          feature.setStyle(null);
          this.pointsController.removeSelectedFeature(feature);
        }
      });
    }

    unSelectCoordPointFeatures(){
      this.configController.currentConfiguration.coordPoints.forEach( point => {
        if(point.isselected){
          // let feature:Feature = this.pointsController.coordinatePointsLayers.childLayers[0].layers.find((element) => element.id === point.type.toLowerCase())
          // .olLayer.getSource().getFeatureById(point.id);
          // feature.setStyle(null);
          // this.pointsController.removeSelectedFeature(feature);
          const indexToFeatMap: [number, Feature] = this.pointsController.getCoordinatePointFeatureMapById(point.id.toString());
          this.pointsController.removeSelectedFeatureCoordinatePointFromLayer(indexToFeatMap[0],
            this.pointsController.getLayerIdFromCoordPointType(indexToFeatMap[1].get("type")),
            !indexToFeatMap[1].get("userdefined"))
        }
      });
    }

    unSelectProcedureFeatures(){
      this.configController.currentConfiguration.procedures.forEach( proc => {
        if(proc.isselected){
          let feature:Feature = null;
          this.pointsController.proceduresLayers.childLayers[0].layers.find((element) => element.id === proc.proceduretype.toLowerCase())
          .olLayer.getSource().getFeatures().forEach( feat => {
            if(feat.getProperties().id == proc.id){
              feature = feat;
              return;
            }
          })
          if (feature != null){
            feature.setStyle(null);
            this.pointsController.removeSelectedFeature(feature);
          }
        }
      });
    }

    unSelectAirspaceFeatures(){
      this.configController.currentConfiguration.airspaceBoundaries.forEach( airspace => {
        if(airspace.isselected){
          let feature:Feature = null;
          this.pointsController.airspaceboundariesLayers.childLayers[0].layers[0]
          .olLayer.getSource().getFeatures().forEach( feat => {
            if(feat.getProperties().id == airspace.id){
              feature = feat;
              return;
            }
          })
          if (feature != null){
            feature.setStyle(null);
            this.pointsController.removeSelectedFeature(feature);
          }
        }
      });
    }

    selectNavaidRow(navaid: NavaidModel) : void{
      this.configController.currentConfiguration.navaids.forEach ( nav => {
        //nav.isselected = false;
        if(navaid.id == nav.id){
          nav.isselected = !nav.isselected;
        }
      })
    }

    selectCoordPointRow(coord_point: CoordinatePointModel) : void{
      this.configController.currentConfiguration.coordPoints.forEach ( point => {
        //nav.isselected = false;
        if(coord_point.id == point.id){
          point.isselected = !point.isselected;
        }
      })
    }

    selectProcedureRow(proc: ProcedureModel) : void{
      this.configController.currentConfiguration.procedures.forEach ( prc => {
        //nav.isselected = false;
        if(proc.id == prc.id){
          prc.isselected = !prc.isselected;
        }
      })
    }

    selectAirspaceBoundaryRow(airspaceBoundary: AirSpaceBoundaryModel) : void{
      this.configController.currentConfiguration.airspaceBoundaries.forEach ( airspace => {
        //nav.isselected = false;
        if(airspaceBoundary.id == airspace.id){
          airspace.isselected = !airspace.isselected;
        }
      })
    }

    saveSettings() :void {
      var config = ConfigurationModel.mapToService(this.configController.currentConfiguration);
      config.projectId = this.projectController.activeProject.id;
      this.configController.saveConfigLists(config).subscribe(
        (data) => {
          this.addProjectController.active = !this.addProjectController.active;
          this.toolsControlService.navigationOnTop = false;
          this.modalService.showMesssageModal("Project Details Saved", "The project details were saved successfully.");
          this.tabsService.closeTab();
        }, (error) => {
          if (error && error.status == 401) {
            this.modalService.showMesssageModal(
              'Error',
              'Default Project is not editable.'
            )
            return;
          }
          this.modalService.showMesssageModal("Error", "Error saving project details.");
        },
        () => {

        });
    }
}
